export default __webpack_public_path__ + "static/media/bilal.b6a911e0.png";